import { useState } from 'react';
import { TabsUI } from '../Interface';
import UserDataFields from './UserDataFields';
import UserGroupUserLinks from './UserGroupUserLinks';
import ProjectTypeUserLinks from './ProjectTypeUserLinks';

const UserTabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Dolgozói adatok',
      content: <UserDataFields {...props} />,
    },
    {
      id: 1,
      name: 'Felhasználói csoportok',
      content: <UserGroupUserLinks {...props} />,
    },
    {
      id: 2,
      name: 'Kezdőképernyő beállítások',
      content: <ProjectTypeUserLinks {...props} />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default UserTabs;
